module.exports = __webpack_public_path__ + "static/media/accidente_personal.b230ded9.svg";